import {TFunction} from "i18next";
import * as yup from "yup";

const requiredTrimmedString = (t: TFunction) =>
    yup
        .string()
        .required(t("validation_inputRequired"))
        .test(
            "no-leading-trailing-spaces",
            t("validation_noLeadingTrailingSpaces"),
            (value) => value === undefined || value.trim() === value
        );

const nullableTrimmedString = (t: TFunction) =>
    yup
        .string()
        .nullable()
        .test(
            "no-leading-trailing-spaces",
            t("validation_noLeadingTrailingSpaces"),
            (value) => value?.trim() === value
        );

export const getOrderAdminUserValidationSchema = (t: TFunction) =>
    yup.object({
        adminUser: yup.object({
            email: yup.string().email(t("validation_invalidEmail")).required(t("validation_inputRequired")),
            firstName: requiredTrimmedString(t),
            lastName: requiredTrimmedString(t),
            phone: requiredTrimmedString(t),
            language: requiredTrimmedString(t),
            timeZone: nullableTrimmedString(t),
        }),
    });

export const getOrderShippingRecipientValidationSchema = (t: TFunction) =>
    yup.object({
        shippingRecipient: yup.object({
            companyName: requiredTrimmedString(t),
            contact: yup.object({
                firstName: requiredTrimmedString(t),
                lastName: requiredTrimmedString(t),
                email: yup.string().email(t("validation_invalidEmail")).required(t("validation_inputRequired")),
                phone: nullableTrimmedString(t),
            }),
            address: yup.object({
                street: requiredTrimmedString(t),
                houseNumber: nullableTrimmedString(t),
                addressAddition: nullableTrimmedString(t),
                postalCode: requiredTrimmedString(t),
                city: requiredTrimmedString(t),
                country: yup.string().required(t("validation_inputRequired")),
            }),
        }),
    });
